import { render, staticRenderFns } from "./MedicalTrendManage.vue?vue&type=template&id=d3a23168&"
import script from "./MedicalTrendManage.vue?vue&type=script&lang=js&"
export * from "./MedicalTrendManage.vue?vue&type=script&lang=js&"
import style0 from "./MedicalTrendManage.vue?vue&type=style&index=0&id=d3a23168&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3a23168')) {
      api.createRecord('d3a23168', component.options)
    } else {
      api.reload('d3a23168', component.options)
    }
    module.hot.accept("./MedicalTrendManage.vue?vue&type=template&id=d3a23168&", function () {
      api.rerender('d3a23168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/medicaltrend-manage/MedicalTrendManage.vue"
export default component.exports